export const GET_TRANSACTION = 'SMS_NOTIFICATIONS/get_transaction';
export const SHOW_TRANSACTION = 'SMS_NOTIFICATIONS/show_transaction';
export const CREATE_SMS_NOTIFICATIONS = 'SMS_NOTIFICATION/create_sms_notifications';
export const RESEND_SMS_NOTIFICATIONS = 'SMS_NOTIFICATION/resend_sms_notifications';

export const FORM_DATA = {
  mobile_number: '',
  email: '',
  message: ''
};
